export class TableFilter {
        orderBy: string = 'Id desc'
        filter: string = ''
        page: number = 1
        rowsOnPage: number = 10
        onlyActive: boolean = false
        parentId?: number = null
        customFilter: any = {}
}
